import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./tshirt-designer/lib/store";
import { CanvasProvider } from "./tshirt-designer/hooks/useCanvas";
import { BrowserRouter } from "react-router-dom";
import { UserDataProvider } from "./context/User";
import { CartProvider } from "./context/CartContext"; // ✅ Import CartProvider

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <UserDataProvider>
          <CartProvider>
            <CanvasProvider>
              <App />
            </CanvasProvider>
          </CartProvider>
        </UserDataProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
